import { createIcon } from '@chakra-ui/icon';
export var ListIcon = createIcon({
  displayName: 'ListIcon',
  d: 'M3 3a2 2 0 100 4 2 2 0 000-4zm0 7a2 2 0 100 4 2 2 0 000-4zm-2 9a2 2 0 114 0 2 2 0 01-4 0zM8 4a1 1 0 000 2h14a1 1 0 100-2H8zm-1 8a1 1 0 011-1h14a1 1 0 110 2H8a1 1 0 01-1-1zm1 6a1 1 0 100 2h14a1 1 0 100-2H8z'
});
//# sourceMappingURL=List.js.map